<template>
  <div class="library-container">
    <div class="library-nav">
        <div class="library-nav-header">
            <div class="library-nav-header-left">
                <img src="@/assets/images/library.svg"></img>
                <p>创建题库<span>(共{{ libraryList.length }}组)</span></p>
            </div>
            <div class="library-nav-header-right" @click="handleCreateClick">
                <img src="@/assets/images/add_library.svg"></img>
            </div>
          </div>
        <div class="library-nav-body">
            <div class="library-nav-item" v-for="(item, index) in libraryList" :key="index" @click="handleNameClick(item, index)">
                <p :class="{'active': libraryClickIndex === index}">{{ `${item.libraryName} (${item.questionNum})`  }}</p>
                <div class="library-nav-item-setting">
                  <img src="@/assets/images/library_setting.svg" @click.stop="handleSettingLibraryClick(item)"></img>
                  <img src="@/assets/images/library_delete.svg" @click.stop="handleDeleteLibraryClick(item)" style="margin-left: 5px;"></img>
                </div>
            </div>
        </div>
    </div>
    <div class="library-content">
      <div class="library-content-header">
        <div class="library-content-header-left">
          <el-select
            v-model="value"
            placeholder="请选择"
            style="width: 191px; background: #f7f7f7; border: 1px solid #ededed"
            @change="handleTypeChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <div class="search-input">
            <input
              v-model="inputValue"
              placeholder="请搜索题目"
              clearable
            ></input>
          </div>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;" @click="handleSearchClick"></el-button>
        </div>
        <div class="library-content-header-right">
          <el-button type="primary" icon="el-icon-plus" @click="handleAddClick">添加题目</el-button>
        </div>
      </div>
      <div class="library-content-list">
        <el-table
          :data="libraryQuestionList"
          :border="true"
          style="width: 100%; margin-top: 10px;"
          :header-cell-style="{ background: '#F6F7FA' }"
          :cell-style="{ background: '#ffffff' }"
		  :empty-text="tableLoading ? '加载中' : '暂无数据'"
        >
          <el-table-column prop="date" label="序号" width="100" :align="'center'">
            <template slot-scope="scope">
              <p>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="题目名称" :align="'left'">
            <template slot-scope="scope">
              <p>{{ scope.row.caseProblem }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="所属题库" :align="'center'" width="200">
            <template slot-scope="scope">
              <p>{{ libraryName }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="题目类型" :align="'center'" width="120">
            <template slot-scope="scope">
              <p>{{ getTypeString(scope.row.type) }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" :align="'center'"  width="180">
            <template slot-scope="scope">
              <div class="library-content-list-operation">
                <img src="@/assets/images/library_setting.svg" @click.stop="handleSettingClick(scope.row)"></img>
                <img src="@/assets/images/library_delete.svg" @click.stop="handleDeleteClick(scope.row)"></img>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="library-content-pagination">
        <el-pagination background :page-size="pageSize" :current-page.sync="currentPage" @size-change="handlePageSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <LibraryEditDialog :showDialog.sync="showDialog" :uuid="libraryId" @closeDialog="showDialog = false" :params="dataObj" :operate="libraryOperate" @success="handleEditSuccess"></LibraryEditDialog>
    <el-dialog :title="libraryOperate1 === '创建' ? '创建题库' : '编辑题库'" :visible.sync="createVisible" width="400px" center>
        <el-input v-model="libraryName" placeholder="请输入题库名称" :maxlength="8"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="createVisible = false">取 消</el-button>
            <el-button type="primary" @click="createLibraryConfirm" style="margin-left: 50px;">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { createPCUserLibrary, userLibraryList, myLibraryQuestionList, deleteUserLibrary, deletePCUserLibraryQuestion } from "@/api/index.js";
import LibraryEditDialog from "@/components/LibraryEditDialog/index.vue";
export default {
  components: {
    LibraryEditDialog,
  },
  data() {
    return {
      options: [
        {
          value: "",
          label: "全部题型",
        },
        {
          value: "1",
          label: "单选题",
        },
        {
          value: "2",
          label: "多选题",
        },
        {
          value: "3",
          label: "填空题",
        },
        {
          value: "4",
          label: "多项填空",
        },
        {
          value: "5",
          label: "下拉",
        },
        {
          value: "6",
          label: "NPS",
        },
        {
          value: "7",
          label: "投票",
        },
        {
          value: "8",
          label: "排序",
        },
        {
          value: "9",
          label: "备注",
        },
        {
          value: "10",
          label: "分数评定",
        },
        {
          value: "11",
          label: "问答",
        },
        {
          value: "12",
          label: "权重评分",
        },
        {
          value: "13",
          label: "评星",
        },
        {
          value: "14",
          label: "姓名",
        },
        {
          value: "15",
          label: "性别",
        },
        {
          value: "16",
          label: "年龄",
        },
        {
          value: "17",
          label: "电话号",
        },
        {
          value: "18",
          label: "邮箱",
        },
        {
          value: "19",
          label: "日期",
        },
        {
          value: "20",
          label: "时间",
        },
        {
          value: "21",
          label: "地址",
        },
        {
          value: "23",
          label: "图片",
        },
        {
          value: "24",
          label: "MaxDiff题",
        }
        ,
        {
          value: "25",
          label: "上传文件",
        },
        {
          value: "26",
          label: "下载附件",
        },
        {
          value: "27",
          label: "联极题",
        },
        // {
        //   value: "28",
        //   label: "完形填空",
        // },
        {
          value: "29",
          label: "出生日期",
        },
        {
          value: "30",
          label: "身份证号",
        },
        {
          value: "31",
          label: "学历",
        },
        {
          value: "32",
          label: "微信号",
        },
      ],
      QuestionType: this.$store.getters["question/getQuestionType"],
      value: "",
      inputValue: "",
      selectValue: null,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      showDialog: false,
      createVisible: false,
      libraryName: '',
      libraryType: 1,
      libraryId: null,
      libraryList: [],
      libraryQuestionList: [],
      libraryOperate: "0",
      dataObj: null,
      inputType: "",
      libraryClickIndex: 0,
      libraryOperate1: "创建",
      loading: null,
	  tableLoading: false
    };
  },
  created() {},
  mounted() {
    console.log("dqdwq12332132123pwerp[ewore[pw]]", this.$route.query.id);
    
    if (this.$route.query.id) {
      this.libraryId = parseInt(this.$route.query.id);
    }
    this.getLibraryList();
  },
  methods: {
    handlePageSizeChange(val) {
      console.log("dqfqwfqwuyfvqwfqwfqywtfqwt111y");
      
      this.currentPage = 1;
      this.pageSize = val;
      this.getLibraryQuestionList();
    //   this.getList();
    },
    handleCurrentChange(val) {
      console.log("dqfqwfqwuyfvqwfqwfqywtfqwty");
      
      this.currentPage = val;
      this.getLibraryQuestionList();
    //   this.getList();
    },
    handleTypeChange(e) {
      if (e === "") {
        this.selectValue = null;
      } else {
        this.selectValue = parseInt(e);
      }
      this.getLibraryQuestionList();
    },
    handleSearchClick() {
      this.currentPage = 1;
      this.getLibraryQuestionList();
    },
    handleCreateClick() {
      this.createVisible = true;
      this.libraryOperate1 = "创建";
      this.libraryName = '';
      // this.libraryId = null
      this.dataObj = null
    },
    handleSettingClick(row) {
      this.showDialog = true;
      this.libraryOperate = "1";
      this.dataObj = row;
    },
    handleDeleteClick(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log("ie90129812gr21r7812r1", row);
        
        deletePCUserLibraryQuestion({
          id: row.id,
        }).then(res => {
          console.log("==============", res);
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getLibraryQuestionList();
            this.libraryList[this.libraryClickIndex].questionNum = this.libraryList[this.libraryClickIndex].questionNum - 1;
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
        }).catch(err => {
          this.$message({
            message: err.msg,
            type: 'error'
          });
        });
      })
    },
    handleSettingLibraryClick(row) {
      this.createVisible = true;
      this.libraryId = row.id;
      this.libraryName = row.libraryName;
      this.libraryType = row.libraryType;
      this.libraryOperate1 = "编辑";
      // this.showDialog = true;
      // this.libraryOperate = "1";
      // this.dataObj = row;
    },
    getTypeString(type) {
      switch (type) {
        case this.QuestionType.SCQ:
          return '单选';
        case this.QuestionType.MCQ:
          return '多选';
        case this.QuestionType.SBQ:
          return '填空';
        case this.QuestionType.MBQ:
          return '多项填空';
        case this.QuestionType.DLQ:
          return '下拉';
        case this.QuestionType.NPS:
          return 'NPS';
        case this.QuestionType.VOTE:
          return '投票';
        case this.QuestionType.SORT:
          return '排序';
        case this.QuestionType.REMARK:
          return '备注';
        case this.QuestionType.SCORE:
          return '分数评定';
        case this.QuestionType.QA:
          return '问答';
        case this.QuestionType.WRQ:
          return '权重评分';
        case this.QuestionType.SRQ:
          return '评星';
        case this.QuestionType.NAME:
          return '姓名';
        case this.QuestionType.GENDER:
          return '性别';
        case this.QuestionType.AGE:
          return '年龄';
        case this.QuestionType.TEL:
          return '电话号';
        case this.QuestionType.EMAIL:
          return '邮箱';
        case this.QuestionType.DATE:
          return '日期';
        case this.QuestionType.TIME:
          return '时间';
        case this.QuestionType.ADDR:
          return '地址';
        case this.QuestionType.TFQ:
          return '判断题';
        case this.QuestionType.IMAGE:
          return '图片';
        case this.QuestionType.MaxDiff:
          return "MaxDiff题";
        case this.QuestionType.UploadFile:
          return "上传文件";
        case this.QuestionType.DownloadFile:
          return "下载文件";
        case this.QuestionType.CASCADER:
          return "联级题";
        case this.QuestionType.BDQ:
          return "出生日期";
        case this.QuestionType.IDQ:
          return "身份证号";
        case this.QuestionType.ELQ:
          return "学历";
        case this.QuestionType.WX:
          return "微信号";
      }
    },
    createLibraryConfirm() {
      console.log("81234128745127845127845128745128452");
      
      if (this.libraryName === '') {
        this.$message({
          message: '请输入题库名称',
          type: 'warning'
        });
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      createPCUserLibrary({
        libraryName: this.libraryName,
        libraryType: this.libraryType,
        id: this.libraryOperate1 === '创建' ? null : this.libraryId,
      }).then(res => {
        console.log("==============", res);
        if (res.code === 200) {
          this.$message({
            message: this.libraryOperate1 === '创建' ? '创建成功' : '编辑成功',
            type: 'success'
          });
          this.createVisible = false;
          this.libraryName = '';
          this.libraryId = res.data;
          this.getLibraryList();
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        this.loading.close();
      }).catch(err => {
        this.loading.close();
      })
    },
    handleAddClick() {
      if (this.libraryList.length === 0) {
        this.$message({
          message: '请先创建题库分组',
          type: 'warning'
        });
        return;
      }
      this.showDialog = true;
      this.libraryOperate = "0";
      this.dataObj = null
    },
    getLibraryList() {
		this.tableLoading = true
      userLibraryList({
        libraryType: this.libraryType,
      }).then(res => {
        console.log("==============1", res, this.libraryId);
        if (res.code === 200) {
          this.libraryList = res.data;
          if (this.libraryId === null) {
            this.libraryId = res.data[0].id;
            this.libraryName = res.data[0].libraryName;
            this.libraryClickIndex = 0;
          } else {
            this.libraryClickIndex = this.libraryList.findIndex(item => item.id === this.libraryId);
            console.log("this.libraryClickIndex", this.libraryClickIndex);
            
          }
          this.getLibraryQuestionList();
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
        console.log("i912u9ry18r2189r21yr981", this.libraryId);
        
      }).catch(err => {
        
      })
    },
    getLibraryQuestionList() {
		this.tableLoading = true
      myLibraryQuestionList({
        libraryId: this.libraryId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        type: this.selectValue,
        caseProblem: this.inputValue,
      }).then(res => {
        console.log("==============2", res);
        if (res.code === 200) {
          this.libraryQuestionList = res.rows;
          this.total = res.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      }).catch((err) => {
		  console.log("err", err);
		})
		.finally(() => {
		  this.tableLoading = false;
		});
    },
    handleDeleteLibraryClick(item) {
      this.$confirm('删除所选的题库分组后，数据不可恢复，您确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUserLibrary({
          id: item.id,
        }).then(res => {
          console.log("==============", res);
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getLibraryList();
          } else {
            this.$message({
              message: res.msg,
              type: 'error'
            });
          }
        }).catch(err => {
          this.$message({
            message: err.msg,
            type: 'error'
          });
        });
      })
    },
    handleNameClick(item, index) {
      this.libraryClickIndex = index;
      this.libraryId = item.id;
      this.libraryName = item.libraryName;
      this.getLibraryQuestionList();
    },
    handleEditSuccess(uuid) {
      console.log("uuid", uuid);
      this.libraryId = uuid;
      this.libraryClickIndex = this.libraryList.findIndex(item => item.id === uuid);
      this.libraryName = this.libraryList[this.libraryClickIndex].libraryName;
      if (this.libraryOperate === '0') {
        this.libraryList[this.libraryClickIndex].questionNum = this.libraryList[this.libraryClickIndex].questionNum + 1;
      }
      this.currentPage = 1;
      this.getLibraryQuestionList();
    },
  },
};
</script>

<style scoped>
.library-container {
  height: 100%;
  display: flex;
}

.library-nav {
  width: 240px;
  height: 100%;
  background: #ffffff;
}

.library-content {
  flex: 1;
  height: 100%;
  background: #ffffff;
  padding: 15px 10px;
  margin-left: 15px;
  overflow: hidden;
  overflow-y: auto;
}

.library-content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.library-content-header-left {
  display: flex;
  align-items: center;
}

.library-content-header-right {
  display: flex;
  align-items: center;
}

.search-input {
  width: 246px;
  height: 42px;
  background: #f7f7f7;
  border: 1px solid #ededed;
  border-radius: 3px;
  padding: 0 10px;
  box-sizing: border-box;
  margin-left: 10px;
  display: flex;
  align-items: center;

  input {
    width: 100%;
  }
}

.search-btn {
  width: 56px;
height: 42px;
background: #1877ff;
border: 1px solid #1877ff;
border-radius: 4px;
display: flex;
align-items: center;
justify-content: center;
}

.library-content-pagination {
    width: 100%;
    text-align: right;
    margin-top: 10px;
}

/deep/ .el-pagination {
  .el-pagination__total {
    font-size: 16px !important;
    color: #909399;
  }

  .el-pagination__sizes {
    .el-select {
        border: 1px solid #F1F3F8;
        border-radius: 3px;
        margin-top: -2px;
      .el-input {
        input {
          font-size: 16px !important;
          color: #909399;
        }  
      }
    }
  }

  .btn-prev {
    .el-icon {
      font-size: 16px !important;
      color: #909399;
    }
  }
  
  .el-pager {
    li {
      font-size: 16px !important;
    }
  }

  .btn-next {
    .el-icon {
      font-size: 16px !important;
      color: #909399;
    }
  }

  .el-pagination__jump {
    font-size: 16px !important;
    color: #909399;

    .el-input {
      .el-input__inner {
        font-size: 16px !important;
        color: #C0C4CC;
      }
      
    }
  }
}

.library-nav-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  height: 50px;
  border-bottom: 1px solid #E7E7E7;
}

.library-nav-header-left {
  display: flex;
  /* align-items: center; */
}

.library-nav-header-left p {
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
    font-weight: Bold;
    text-align: left;
    color: #1877ff;  
}

 .library-nav-header-left p span {
    font-size: 12px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: Regular;
    text-align: left;
    color: #767d98;
}

 .library-nav-header-left img {
    width: 16px;
    height: 16px;
    margin-right: 3px;
}

.library-nav-header-right {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.library-nav-body {
    height: calc(100% - 50px);
    overflow: hidden;
    overflow-y: auto;
    padding: 10px 0;
}

.library-nav-item {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.library-nav-item-setting {
  display: none;
}

.library-nav-item:hover .library-nav-item-setting {
  /* display: block; */
  display: flex;
}

.library-content-list-operation {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.library-content-list-operation img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.active {
  color: #1877ff;
}
</style>



// WEBPACK FOOTER //
// src/views/LibraryList/index.vue